import React from "react";
import { ViewMoreBroadcast } from "../../pages";
import { toJS } from "mobx";
import { adminStore } from "../../stores";

const ViewMoreBroadcastContainer = () => {
  return (
    <ViewMoreBroadcast singleBroadcast={toJS(adminStore.singleBroadcast)} />
  );
};

export default ViewMoreBroadcastContainer;
